export default __webpack_public_path__ + "static/media/wave.09b1edfb.svg";